import React from "react";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import Row from "../../common/layout/row";
import Grid from "../../common/layout/grid";
import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import Select from "../../common/form/select";
import { useState } from "react";
import { TooltipPeriodoTeste } from "./tooltipPeriodoTeste";
import { TooltipAgendamento } from "./tooltipAgendamento";
import { IconesAtingidas } from "./iconesAtingidas";
import DateFnsUtils from "@date-io/date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import ClearIcon from "@material-ui/icons/Clear";
import Button from "../../common/button/button";

export function TabelaContratoDemanda(props) {
    const [abaSazonalSelcionada, setAbaSazonalSelcionada] = useState(true);
    const [filtro, setFiltro] = useState({ competencia_fim_demanda: null });
    const [printMode, setPrintMode] = useState(false);

    function setCompetenciaFinalDemanda(competencia) {
        setFiltro({ ...filtro, competencia_final_demanda: competencia });
    }

    function ordenarVencidosComAlerta(lista) {
        const inicioMesAtual = new Date();
        inicioMesAtual.setDate(1);
        inicioMesAtual.setHours(0, 0, 0, 0);

        const getDataFim = (periodo) => {
            if (!Array.isArray(periodo) || !periodo.length) return null;
            try {
                const ultimo = JSON.parse(periodo[periodo.length - 1]);
                return new Date(parseInt(ultimo.ano), parseInt(ultimo.mes) - 1, 1);
            } catch {
                return null;
            }
        };

        // Grupo 1: vencidos e não visualizados
        const vencidosNaoVisualizados = lista
            .filter((item) => {
                const dataFim = getDataFim(item.periodo_teste);
                return dataFim && dataFim < inicioMesAtual && !item.alerta_periodo_teste_visualizado;
            })
            .sort((a, b) => {
                const dataA = getDataFim(a.periodo_teste);
                const dataB = getDataFim(b.periodo_teste);
                return dataA - dataB;
            });

        // Grupo 2: vencidos já visualizados
        const vencidosVisualizados = lista
            .filter((item) => {
                const dataFim = getDataFim(item.periodo_teste);
                return dataFim && dataFim < inicioMesAtual && item.alerta_periodo_teste_visualizado;
            })
            .sort((a, b) => {
                const dataA = getDataFim(a.periodo_teste);
                const dataB = getDataFim(b.periodo_teste);
                return dataA - dataB;
            });

        // Grupo 3: os demais (vigentes ou sem período)
        const outros = lista.filter((item) => {
            const dataFim = getDataFim(item.periodo_teste);
            return !dataFim || dataFim >= inicioMesAtual;
        });

        // Junta tudo
        return [...vencidosNaoVisualizados, ...vencidosVisualizados, ...outros];
    }

    const filtroCompetenciaFinalDemanda = filtro.competencia_final_demanda
        ? `${String(filtro.competencia_final_demanda).substring(0, 4)}/${String(filtro.competencia_final_demanda).substring(4, 6)}/01 12:00:00`
        : null;

    const unidadeConsumidora = props.listaUnidadeConsumidora.filter((item) => item.id == props.filtro.id_unidade_consumidora)[0];

    const exibirTabela = props.filtro.id_cliente > 0;

    return (
        <>
            <ContentCard style={{ backgroundColor: "#fff" }}>
                <ContentCardBody>
                    <Row>
                        <Select
                            name="demanda_contrato_tipos"
                            options={props.listaDemandaContratoTipo.filter((tipo) => {
                                const ucFiltradaPeloCliente = props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente);
                                const condicaoForaPonta = tipo.id == 1;
                                const condicaoPonta = tipo.id == 2 && !!ucFiltradaPeloCliente.find((uc) => uc.id_modalidade_tarifaria == 2); //alguma uc do cliente selecionado tem q ser horosazonal azul
                                const condicaoGeracao = tipo.id == 3 && !!ucFiltradaPeloCliente.find((uc) => uc.geracao && [1, 4].includes(parseInt(uc.id_grupo_faturamento))); //alguma uc do cliente selecionado tem q ser geradora
                                return condicaoForaPonta || condicaoPonta || condicaoGeracao;
                            })}
                            label="Tipo de Contrato de Demanda"
                            cols="12 4 4 4"
                            placeholder="Selecione o tipo de contrato de demanda"
                            value={props.filtro.id_tipo_contrato_demanda}
                            isClearable={false}
                            isSearchable={false}
                            onChange={(data) => props.handleChangeFiltroTipoContrato(data)}
                        />
                        {props.usuarioLogado.acesso_cliente ? null : (
                            <Grid cols="12 4 4 4">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                                    <DatePicker
                                        fullWidth
                                        disabled={!abaSazonalSelcionada}
                                        variant="inline"
                                        openTo="year"
                                        views={["year", "month"]}
                                        label="Filtrar demanda com competência final até:"
                                        InputLabelProps={{ shrink: true, style: { color: abaSazonalSelcionada ? "#222" : "#aab", fontSize: "1.25rem" } }}
                                        autoOk
                                        value={filtroCompetenciaFinalDemanda}
                                        onChange={(value) => {
                                            const competenciaFinalDemanda = value
                                                ? parseInt(`${value.getFullYear()}${value.getMonth() < 9 ? "0" : ""}${value.getMonth() + 1}`)
                                                : null;

                                            setCompetenciaFinalDemanda(competenciaFinalDemanda);
                                        }}
                                        InputProps={{
                                            style: { height: 48 },
                                            endAdornment: filtroCompetenciaFinalDemanda ? (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        size="small"
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            setCompetenciaFinalDemanda(null);
                                                        }}
                                                    >
                                                        <ClearIcon fontSize="small" />
                                                    </IconButton>
                                                </InputAdornment>
                                            ) : null,
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        )}
                    </Row>
                </ContentCardBody>
            </ContentCard>

            <ContentCard
                style={{
                    backgroundColor: "#30303d",
                    color: "#fff",
                    display: !unidadeConsumidora || [1, 4].includes(parseInt(unidadeConsumidora.id_grupo_faturamento)) ? "" : "none",
                }}
            >
                <ContentCardBody style={{ backgroundColor: "#30303d", overflowX: "scroll" }}>
                    {props.usuarioLogado.acesso_cliente ? null : (
                        <Row alignRight style={{ paddingRight: 5 }}>
                            <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                    text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                    title="Exportar"
                                    type={"dark"}
                                    solid={true}
                                    icon={"fa fa-file-export"}
                                    disabled={!exibirTabela || !props.listaDemandaContagem.length}
                                    event={() => {
                                        setPrintMode(true);
                                        setTimeout(() => props.handleExport({ callback: () => setPrintMode(false) }), 200);
                                    }}
                                />
                            </Grid>
                        </Row>
                    )}
                    <ContentCardBody style={{ minWidth: 980, paddingTop: printMode ? 2000 : 0 }}>
                        <Row>
                            <Grid cols="12 12 12 12">
                                {printMode ? (
                                    <div
                                        id="titulo-com-abas"
                                        className="text-center"
                                        style={{ fontSize: 16, height: 100, paddingTop: 30, display: "flex", justifyContent: "center", alignItems: "center", visibility: "hidden" }}
                                    >
                                        Resumo dos Contratos de Demandas ({abaSazonalSelcionada ? "Sazonais" : "Não Sazonais"})
                                    </div>
                                ) : (
                                    <p className="text-center" style={{ fontSize: 16 }}>
                                        Resumo dos Contratos de Demandas
                                    </p>
                                )}
                            </Grid>
                            <Grid
                                cols="4 4 4 4"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    marginLeft: 7,
                                    backgroundColor: abaSazonalSelcionada ? "#30303d" : "#282833",
                                    color: abaSazonalSelcionada ? "#FFF" : "#9b9b9b",
                                    marginBottom: 0,
                                    zIndex: abaSazonalSelcionada ? 1 : 0,
                                    borderRadius: "10px 10px 0 0",
                                    border: `solid 1px ${abaSazonalSelcionada ? "#ddd" : "#282833"}`,
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                                onClick={() => {
                                    setAbaSazonalSelcionada(true);
                                }}
                            >
                                <h6>Sazonal</h6>
                            </Grid>
                            <Grid
                                cols="4 4 4 4"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    backgroundColor: abaSazonalSelcionada ? "#282833" : "#30303d",
                                    color: abaSazonalSelcionada ? "#9b9b9b" : "#FFF",
                                    marginBottom: 0,
                                    zIndex: abaSazonalSelcionada ? 0 : 1,
                                    borderRadius: "10px 10px 0 0",
                                    border: `solid 1px ${abaSazonalSelcionada ? "#282833" : "#ddd"}`,
                                    cursor: "pointer",
                                    textAlign: "center",
                                }}
                                onClick={() => {
                                    setCompetenciaFinalDemanda(null);
                                    setAbaSazonalSelcionada(false);
                                }}
                            >
                                <h6>Não Sazonal</h6>
                            </Grid>
                        </Row>
                        <Table id="tabela-contratos-demanda" responsive>
                            <THead>
                                <Tr>
                                    <Th sticky backgroundColor="#30303d" alignCenter colSpan={"2"}>
                                        Demandas Atingidas
                                    </Th>
                                    {props.usuarioLogado.administrador ? (
                                        <Th sticky backgroundColor="#30303d">
                                            Cliente
                                        </Th>
                                    ) : null}
                                    <Th sticky backgroundColor="#30303d">
                                        Unidade Consumidora
                                    </Th>
                                    <Th sticky backgroundColor="#30303d"></Th>
                                    <Th sticky backgroundColor="#30303d"></Th>
                                    {abaSazonalSelcionada ? (
                                        <>
                                            <Th sticky backgroundColor="#30303d" alignCenter>
                                                Início
                                            </Th>
                                            <Th sticky backgroundColor="#30303d" alignCenter>
                                                Fim
                                            </Th>
                                            <Th sticky backgroundColor="#30303d" alignCenter>
                                                Faturas do Ciclo
                                            </Th>
                                        </>
                                    ) : (
                                        <>
                                            <Th sticky backgroundColor="#30303d" alignCenter>
                                                Primeiro Mês Não Sazonal
                                            </Th>
                                            <Th sticky backgroundColor="#30303d" alignCenter>
                                                Nº Meses Sem Sazonalidade
                                            </Th>
                                        </>
                                    )}
                                    <Th sticky backgroundColor="#30303d" alignCenter>
                                        Sazonalidade
                                    </Th>
                                    <Th sticky backgroundColor="#30303d" alignCenter>
                                        Fator de Carga
                                    </Th>
                                    <Th sticky backgroundColor="#30303d" alignCenter>
                                        Fator de Demanda
                                    </Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {exibirTabela &&
                                    ordenarVencidosComAlerta(props.listaDemandaContagem)
                                        .filter((item) => {
                                            const filtroAba = abaSazonalSelcionada ? item.contrato_demanda_sazonal : !item.contrato_demanda_sazonal;
                                            const filtroCompetenciaFim =
                                                !abaSazonalSelcionada ||
                                                (abaSazonalSelcionada && (!filtro.competencia_final_demanda || item.competencia_fim <= filtro.competencia_final_demanda));
                                            return filtroAba && filtroCompetenciaFim;
                                        })
                                        .map((item, i) => {
                                            const sazonalidadeDiferenteDaUC = item.contrato_demanda_sazonal != item.sazonal;

                                            let restantes = item.competencias - item.lidas;
                                            let cor = "#fff";
                                            if (item.atingidas < 3) {
                                                if (restantes <= 3 && item.atingidas <= 1) {
                                                    cor = "#ba2825";
                                                } else if (restantes <= 4 && item.atingidas <= 2) {
                                                    cor = "#eeff41";
                                                }
                                            }

                                            return (
                                                <Tr key={item.id}>
                                                    {abaSazonalSelcionada ? (
                                                        <>
                                                            <Td minWidth={120} color={item.atingidas >= 2 ? "#fff" : "#000"} backgroundColor={"#fff"} alignCenter>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexWrap: "nowrap",
                                                                        fontWeight: "bold",
                                                                        backgroundColor: "#FFF",
                                                                        width: "max-content",
                                                                        border: `3px solid ${item.atingidas >= 3 ? "#0bf97f" : "#000"}`,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            margin: 3,
                                                                            display: "flex",
                                                                            flexWrap: "nowrap",
                                                                            fontWeight: "bold",
                                                                            backgroundColor: item.atingidas > 0 ? "#6affa2" : "#FFF",
                                                                            width: "max-content",
                                                                            color: item.atingidas >= 3 ? "#0f6b31" : "#000",
                                                                        }}
                                                                    >
                                                                        <span style={{ padding: "4px 10px" }}>{item.atingidas}</span> <IconesAtingidas item={item} />
                                                                    </div>
                                                                </div>
                                                            </Td>
                                                            <Td
                                                                color={"#fff"}
                                                                title={`Total de ultrapassagens:${parseInt(item.ultrapassagens || 0)}`}
                                                                minWidth={40}
                                                                backgroundColor={parseInt(item.ultrapassagens) ? "#fa3c3c" : "black"}
                                                                alignCenter
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        flexGrow: 1,
                                                                        flexDirection: "column",
                                                                        borderRadius: 3,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize: "1.4rem",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                        className="info-box-icon"
                                                                    >
                                                                        <i className="fas fa-angle-double-up"></i>
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: "0.9rem",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                        className="info-box-number"
                                                                    >
                                                                        {item.ultrapassagens}
                                                                    </div>
                                                                </div>
                                                            </Td>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Td>
                                                                <div
                                                                    style={{
                                                                        margin: 0,
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        padding: "5px 5px 0px 5px",
                                                                        minHeight: "fit-content",
                                                                    }}
                                                                    className="info-box bg-green"
                                                                    title="Demandas Atingidas sem Ultrapassagens"
                                                                >
                                                                    <span
                                                                        className="info-box-icon"
                                                                        style={{
                                                                            width: window.innerWidth < 576 ? 20 : 70,
                                                                            fontSize: "1.3rem",
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-angle-up"></i>
                                                                    </span>
                                                                    <span style={{ margin: 0 }} className="info-box-number">
                                                                        {item.atingidas - (item.ultrapassagens || 0)}
                                                                    </span>
                                                                </div>
                                                            </Td>
                                                            <Td>
                                                                <div
                                                                    style={{
                                                                        margin: 0,
                                                                        flexDirection: "column",
                                                                        alignItems: "center",
                                                                        padding: "5px 5px 0px 5px",
                                                                        minHeight: "fit-content",
                                                                    }}
                                                                    className="info-box bg-red"
                                                                    title="Demandas Atingidas com Ultrapassagens"
                                                                >
                                                                    <span
                                                                        className="info-box-icon"
                                                                        style={{
                                                                            width: window.innerWidth < 576 ? 20 : 70,
                                                                            fontSize: "1.3rem",
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-angle-double-up"></i>
                                                                    </span>
                                                                    <span style={{ margin: 0 }} className="info-box-number">
                                                                        {item.ultrapassagens || 0}
                                                                    </span>
                                                                </div>
                                                            </Td>
                                                        </>
                                                    )}
                                                    {props.usuarioLogado.administrador ? (
                                                        <Td padding={10} color="#fff">
                                                            {item.nome_cliente}
                                                        </Td>
                                                    ) : null}
                                                    <Td color="#fff" padding={10}>
                                                        {item.nome_unidade_consumidora}
                                                    </Td>
                                                    {sazonalidadeDiferenteDaUC ? (
                                                        <Td colSpan="2">
                                                            {" "}
                                                            <div
                                                                style={{
                                                                    backgroundColor: "#fd5959",
                                                                    color: "#ffffff",
                                                                    padding: 5,
                                                                    borderRadius: "0.3rem",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                <div style={{ width: "100%", textWrap: "nowrap" }}>A sazonalidade da UC é diferente do contrato</div>
                                                                <div>
                                                                    (UC:
                                                                    {item.contrato_demanda_sazonal ? " Sazonal " : " Não Sazonal "} - Contrato:
                                                                    {item.sazonal ? " Sazonal " : " Não Sazonal "})
                                                                </div>
                                                            </div>
                                                        </Td>
                                                    ) : (
                                                        <>
                                                            <Td padding={10} colSpan={item.periodo_teste ? 1 : 2}>
                                                                <TooltipAgendamento
                                                                    item={item}
                                                                    usuarioLogado={props.usuarioLogado}
                                                                    handleExcluirAgendamento={props.handleExcluirAgendamento}
                                                                />
                                                            </Td>
                                                            {item.periodo_teste ? (
                                                                <Td padding={10} color="#fff">
                                                                    <TooltipPeriodoTeste
                                                                        periodoTeste={item.periodo_teste || []}
                                                                        item={item}
                                                                        usuarioLogado={props.usuarioLogado}
                                                                        handleClickTooltipPeriodoTeste={props.handleClickTooltipPeriodoTeste}
                                                                        handleExcluirPeriodoTeste={props.handleExcluirPeriodoTeste}
                                                                    />
                                                                </Td>
                                                            ) : null}
                                                        </>
                                                    )}
                                                    {abaSazonalSelcionada ? (
                                                        <>
                                                            <Td padding={10} color="#fff" alignCenter>
                                                                {sazonalidadeDiferenteDaUC
                                                                    ? "-"
                                                                    : `${String(item.competencia_inicio).substring(4, 6)}/${String(item.competencia_inicio).substring(0, 4)}`}
                                                            </Td>
                                                            <Td padding={10} color="#fff" alignCenter>
                                                                {sazonalidadeDiferenteDaUC
                                                                    ? "-"
                                                                    : `${String(item.competencia_fim).substring(4, 6)}/${String(item.competencia_fim).substring(0, 4)}`}
                                                            </Td>
                                                        </>
                                                    ) : (
                                                        <Td padding={10} color="#fff" alignCenter>
                                                            {sazonalidadeDiferenteDaUC
                                                                ? "-"
                                                                : `${String(item.competencia_base_sazonalidade).substring(4, 6)}/${String(
                                                                      item.competencia_base_sazonalidade
                                                                  ).substring(0, 4)}`}
                                                        </Td>
                                                    )}
                                                    {item.sazonal ? (
                                                        <Td
                                                            color={cor}
                                                            fontWeight="bold"
                                                            title={
                                                                item.competencias - item.lidas > 3 - item.atingidas || item.atingidas >= 3
                                                                    ? null
                                                                    : item.competencias - item.lidas == 3 - item.atingidas
                                                                      ? `É necessário atingir ${3 - item.atingidas} demanda${3 - item.atingidas > 1 ? "s" : ""} e resta${
                                                                            item.competencias - item.lidas > 1 ? "m" : ""
                                                                        } ${item.competencias - item.lidas} fatura${item.competencias - item.lidas > 1 ? "s" : ""} no ciclo sazonal`
                                                                      : `É necessário atingir ${3 - item.atingidas} demanda${3 - item.atingidas > 1 ? "s" : ""} e ${
                                                                            item.competencias == item.lidas
                                                                                ? "o ciclo sazonal já está completo"
                                                                                : `resta${item.competencias - item.lidas > 1 ? "m" : ""} ${item.competencias - item.lidas} fatura${
                                                                                      item.competencias - item.lidas > 1 ? "s" : ""
                                                                                  } no ciclo sazonal`
                                                                        }`
                                                            }
                                                            backgroundColor={
                                                                item.competencias - item.lidas > 3 - item.atingidas || item.atingidas >= 3
                                                                    ? null
                                                                    : item.competencias - item.lidas == 3 - item.atingidas
                                                                      ? "#ffb74d"
                                                                      : "#e57373"
                                                            }
                                                            alignCenter
                                                        >
                                                            {sazonalidadeDiferenteDaUC ? "-" : `${item.lidas || 1} de ${item.competencias}`}
                                                        </Td>
                                                    ) : (
                                                        <Td padding={10} color="#fff" alignCenter>
                                                            {item.meses_nao_sazonal || 1}
                                                        </Td>
                                                    )}
                                                    <Td
                                                        fontWeight={parseFloat(item.sazonalidade) <= 0.2 ? "bold" : "normal"}
                                                        color={parseFloat(item.sazonalidade) <= 0.2 ? "#3f3" : "#fff"}
                                                        backgroundColor="#40838f"
                                                        alignCenter
                                                    >
                                                        {sazonalidadeDiferenteDaUC ? "-" : parseFloat(item.sazonalidade).toFixed(2).replace(".", ",")}
                                                    </Td>
                                                    <Td backgroundColor="#317ffe" alignCenter width={120}>
                                                        {item.id_modalidade_tarifaria == 1 ? (
                                                            <div> {isNaN(parseFloat(item.fator_carga)) ? " - " : parseFloat(item.fator_carga).toFixed(2).replace(".", ",")}</div>
                                                        ) : item.id_modalidade_tarifaria == 2 ? (
                                                            <div>
                                                                <div>
                                                                    {"FP: "}{" "}
                                                                    {isNaN(parseFloat(item.fator_carga_fora_ponta))
                                                                        ? " - "
                                                                        : parseFloat(item.fator_carga_fora_ponta).toFixed(2).replace(".", ",")}
                                                                </div>
                                                                <div>
                                                                    {"P: "}{" "}
                                                                    {isNaN(parseFloat(item.fator_carga_ponta))
                                                                        ? " - "
                                                                        : parseFloat(item.fator_carga_ponta).toFixed(2).replace(".", ",")}
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </Td>
                                                    <Td backgroundColor="#ffa556" alignCenter width={120}>
                                                        {item.id_modalidade_tarifaria == 1 ? (
                                                            <div>
                                                                {" "}
                                                                {isNaN(parseFloat(item.fator_demanda_fora_ponta))
                                                                    ? " - "
                                                                    : parseFloat(item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}
                                                            </div>
                                                        ) : item.id_modalidade_tarifaria == 2 ? (
                                                            <div>
                                                                <div>
                                                                    {"FP: "}{" "}
                                                                    {isNaN(parseFloat(item.fator_demanda_fora_ponta))
                                                                        ? " - "
                                                                        : parseFloat(item.fator_demanda_fora_ponta).toFixed(2).replace(".", ",")}
                                                                </div>
                                                                <div>
                                                                    {"P: "}{" "}
                                                                    {isNaN(parseFloat(item.fator_demanda_ponta))
                                                                        ? " - "
                                                                        : parseFloat(item.fator_demanda_ponta).toFixed(2).replace(".", ",")}
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </Td>
                                                </Tr>
                                            );
                                        })}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCardBody>
            </ContentCard>
        </>
    );
}
